import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "reports-tab-content" }

import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import IconReports from '@/components/icons/IconReports.vue';
import PageView from '@/components/ui/PageView.vue';
import SectionTabView from '@/components/ui/SectionTabView.vue';
import ReportsPaymentsTab from '@/views/reports/ReportsPaymentsTab.vue';
import ReportsAccountsTab from '@/views/reports/ReportsAccountsTab.vue';
import ReportsPortfolioRiskTab from '@/views/reports/ReportsPortfolioRiskTab.vue';
import type { SectionTab } from '@/components/ui/SectionTabView.vue';

type ReportsTabId = 'payments' | 'accounts' | 'portfolio-risk';

const DEFAULT_TAB_ID: ReportsTabId = 'payments';


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportsView',
  setup(__props) {

/* eslint-env vue/setup-compiler-macros */
const TABS: SectionTab[] = [
    { id: 'payments', label: 'Payments' },
    // PHASE2
    // { id: 'accounts', label: 'Accounts' },
    { id: 'portfolio-risk', label: 'Portfolio Risk' },
];

const route = useRoute();
const router = useRouter();

const isReportsTabId = (value: unknown): value is ReportsTabId => (
    typeof value === 'string'
    && TABS.some((tab) => tab.id === value)
);

const activeTabId = computed<ReportsTabId>(() => {
    const tab = Array.isArray(route.query.tab)
        ? route.query.tab[0]
        : route.query.tab;

    return isReportsTabId(tab) ? tab : DEFAULT_TAB_ID;
});

const selectTab = (tabId: string) => {
    if (!isReportsTabId(tabId) || tabId === activeTabId.value) {
        return;
    }

    const nextQuery = { ...route.query };

    if (tabId === DEFAULT_TAB_ID) {
        delete nextQuery.tab;
    } else {
        nextQuery.tab = tabId;
    }

    router.push({
        name: 'reports',
        query: nextQuery,
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageView, {
    title: "Reports",
    icon: IconReports
  }, {
    default: _withCtx(() => [
      _createVNode(SectionTabView, {
        tabs: TABS,
        "active-tab-id": activeTabId.value,
        onTabChange: selectTab
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (activeTabId.value === 'payments')
              ? (_openBlock(), _createBlock(ReportsPaymentsTab, { key: 0 }))
              : (activeTabId.value === 'accounts')
                ? (_openBlock(), _createBlock(ReportsAccountsTab, { key: 1 }))
                : (activeTabId.value === 'portfolio-risk')
                  ? (_openBlock(), _createBlock(ReportsPortfolioRiskTab, { key: 2 }))
                  : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["active-tab-id"])
    ]),
    _: 1
  }))
}
}

})